// 配额模块
export default {
    Quota: {
        Quota: 'Limit',
        AddQuotaOptions: 'Add Limit Option',
        Name: 'Name',
        deleteIt: 'Are You Sure You Want to Delete?',
        RuleType: 'Rule Type',
        DisplayQuota: 'Show Limit',
        HideQuota: 'Hide Limit',
        QuotaNumber: 'Limit Number',
        CompleteNumber: 'Completion Count',
        RuleName: 'Rule Name',
        DisplayQuotaTip: '(Check the Limit when Answering, It cannot be Selected Once the Limit is Reached)',
        QuotaFullTip: 'Quota full prompt copy',
        QuotaFullPlaceholder: 'Quota is full (up to ten words)',
        HideQuotaTip: '(Check the quota after submitting the answer sheet, and automatically mark it as invalid if the quota is full)',
        RuleCondition1: 'Rule condition 1',
        PleaseSelect: 'Please Select',
        AddConditions: 'Add Conditions',
        RuleCondition2: 'Rule Condition 2',
        QuotaDetails: 'Limit Details',
        NotSetTotalQuota: '(Can be left blank if not limit is to be set)',
        FillDown: 'Fill Down',
        QuotaQuantity: 'Limit Quantity',
        ModifyQuotaCount: 'Modify Limit Number ',
        PleaseEnterModifyQuotaCount: 'Please Enter the Value of the Modified Limit',
        AddQuotaRules: 'Add Limitation Rules',
        ModifyQuotaRules: 'Modify Limitation Rules',
        PleaseEnterNumberQuotasModify: 'Please Enter the Modified Limit Number',
        SuccessfullyDeleted: 'Successfully deleted'
    },
  };